import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BlockHelper from '../blockHelper';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20
    },
    jackpot: {
        position: 'absolute', 
        top: 10, 
        left: 10, 
        fontSize: 14, 
        color: 'gold', 
        textTransform: 'uppercase'
    },
    groups: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255, .3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrapWin: {
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8
    },
    win: {
        color: 'hsla(0,0%,100%,.5)',
        marginRight: 8,
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
    },
    amount: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
    },
    wrapblock: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5,
        marginTop: 8
    },
    w50: {
        width: '50%'
    }
}))


const JackpotItem = ({item}) => {
    const {groups, jackpot, random, max_bet, min_bet, max_win, min_win, primary_amount, secondary_amount, primary_storage, secondary_storage} = item;
    const classes = useStyles();

    return (
        <>
        <div className={classes.root}>
            <span className={classes.jackpot}>
                {jackpot}
            </span>
            <span className={classes.groups}>
                {groups}
            </span>
            <div className={classes.wrapWin}>
                <span className={classes.win}>Выигрыш после:</span>
                <span className={classes.amount}>
                    {new Intl.NumberFormat('ru-RU').format(+random ? (+random).toFixed(2) : +random) }
                </span>
            </div>
            <div className={classes.wrapblock}>
                <div className={classes.w50}>
                    <BlockHelper title="Основной джекпот" amount={new Intl.NumberFormat('ru-RU').format(primary_amount ? primary_amount.toFixed(2) : primary_amount)}/>
                    <BlockHelper title="Первичное накопление" amount={primary_storage} />
                    <BlockHelper title="Мин. ставка" amount={new Intl.NumberFormat('ru-RU').format(min_bet ? min_bet.toFixed(2) : min_bet)} />
                    <BlockHelper title="Мин. выигрыш" amount={new Intl.NumberFormat('ru-RU').format(min_win ? min_win.toFixed(2) : min_win)} />
                </div>
                <div className={classes.w50}>
                    <BlockHelper title="Вторичный джекпот" amount={new Intl.NumberFormat('ru-RU').format(secondary_amount ? secondary_amount.toFixed(2) : secondary_amount)} />
                    <BlockHelper title="Вторичное накопление" amount={secondary_storage} />
                    <BlockHelper title="Макс. ставка" amount={new Intl.NumberFormat('ru-RU').format(max_bet ? max_bet.toFixed(2) : max_bet)} />
                    <BlockHelper title="Макс. выигрыш" amount={new Intl.NumberFormat('ru-RU').format(max_win ? max_win.toFixed(2) : max_win)} />
                </div>
            </div>
        </div>
        </>
    )
}

export default JackpotItem;